import { gql } from "graphql-tag";

export const QUERY_STAGE_SETTINGS = gql`
  query PropertyStageSettings($id: ID!) {
    property(id: $id) {
      id
      name
      stages {
        id
        name
        enabled
        standard
      }
    }
  }
`;

export const TOGGLE_STAGE_SETTINGS = gql`
  mutation ToggleStageSettings($property: ID!, $stage: String!, $enabled: Boolean!) {
    togglePropertyStage(property: $property, stage: $stage, enabled: $enabled) {
      isSuccess
      reason
    }
  }
`;
export const QUERY_INTEREST_LIST_USERS = gql`
  query InterestListUsers($id: ID!) {
    interestListUsers(interestListId: $id) {
      id
      fullName
      email
      roles
      directPhone
      title
    }
  }
`;
